import { Cog, Layers, CircleDot, Square, Save, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { LayoutNodeType } from "@opus-dt/shared-types";

interface Props {
  onAddNode: (type: LayoutNodeType) => void;
  onAddMachine: () => void;
  onSave: () => void;
  onCancel: () => void;
  canSave: boolean;
  isDirty: boolean;
  isSaving?: boolean;
  saveLabel?: string;
}

const ADD_BUTTONS: Array<{ type: LayoutNodeType; label: string; icon: React.ReactNode }> = [
  { type: "MACHINE", label: "Máquina", icon: <Cog className="h-4 w-4" /> },
  { type: "GROUP", label: "Agrupar", icon: <Layers className="h-4 w-4" /> },
  { type: "START", label: "Início", icon: <CircleDot className="h-4 w-4" /> },
  { type: "END", label: "Fim", icon: <Square className="h-4 w-4" /> },
];

export function CanvasToolbar({
  onAddNode,
  onAddMachine,
  onSave,
  onCancel,
  canSave,
  isDirty,
  isSaving,
  saveLabel = "Salvar",
}: Props) {
  return (
    <div
      className="flex flex-wrap items-center gap-1 rounded-md border bg-card/95 p-2 shadow-sm backdrop-blur"
      role="toolbar"
      aria-label="Barra de ferramentas do canvas"
    >
      <span className="mr-2 text-xs font-medium text-muted-foreground">Adicionar:</span>
      {ADD_BUTTONS.map(({ type, label, icon }) => (
        <Button
          key={type}
          size="sm"
          variant="ghost"
          className="h-7 gap-1 px-2 text-xs"
          onClick={() => (type === "MACHINE" ? onAddMachine() : onAddNode(type))}
          aria-label={`Adicionar ${label}`}
        >
          {icon}
          {label}
        </Button>
      ))}
      <div className="ml-auto flex items-center gap-1">
        {isDirty ? (
          <span className="mr-1 text-xs italic text-muted-foreground">Alterações não salvas</span>
        ) : null}
        <Button
          size="sm"
          variant="ghost"
          className="h-7 gap-1 px-2 text-xs"
          onClick={onCancel}
          disabled={isSaving}
        >
          <X className="h-4 w-4" />
          Cancelar
        </Button>
        <Button
          size="sm"
          className="h-7 gap-1 px-2 text-xs"
          onClick={onSave}
          disabled={!canSave || isSaving || !isDirty}
          aria-label="Salvar canvas"
        >
          <Save className="h-4 w-4" />
          {isSaving ? "Salvando…" : saveLabel}
        </Button>
      </div>
    </div>
  );
}
